export { default as HistorialBajasSalidas } from "./HistorialBajasSalidasContainer";
